import '../styling/global.css';
import trustmeeimage from '../assets/trustmee_logo.webp';
import verificationIcon from '../assets/verification_icon.gif';
import gif_file from '../assets/gif_file.gif';
import search from '../assets/search.webp';
import barcode from '../assets/barcode.webp';
import id from '../assets/id.webp';

const ProductTrustmee = () => {
    return (
        <div className="container">
            <img src={trustmeeimage} alt="trustee logo" className="trustmee-image" />
            <div>
                <h1>TrustMee Product Verification Services</h1>
                <p>We offer two distinct services to help brands and manufacturers ensure product authenticity, track sales, and protect against counterfeiting.
                    These services are designed to enhance consumer confidence and safeguard your brand’s reputation.</p>
            </div>
            <img src={verificationIcon} alt="Verification Icon" className="verification-icon" />
            <div>
                <h1>Why Trustmee?</h1>
                <p> Counterfeit products are hard to spot — and they can be unsafe, overpriced, or just plain fake. With TrustMee, you can scan before you buy and
                    instantly know.</p>
            </div>
            <div className="img-row">
                <div className="img-container">
                    <img src={search} alt="trustmee logo" />
                    <span>Search product code</span>
                </div>
                <div className="img-container">
                    <img src={barcode} alt="verification icon" />
                    <span>Search with Barcode</span>
                </div>
                <div className="img-container">
                    <img src={id} alt="verification icon" />
                    <span>Search with Trustmee-ID</span>
                </div>
            </div>
            <p> The scanner reads QR codes or barcodes to display product data &  Product code search finds data through serial number, presenting:</p>
            <div>
                <pre className="template-literal">
                    {` 1) Product Code,
2) Product details,
3) Scan count,
4) Location—helping verify authenticity.
It also includes a reporting feature to alert manufacturers
of potential counterfeiting.

`}
                </pre>
                <h1 style={{ textAlign: "start" }}>How Trustmee Works ?</h1>
                <p> Know exactly what you’re getting.</p><br />
                <p> Check expiry dates, batch info, pricing — right at the shelf or online. See when, where, and how often it’s been scanned — stay in control.</p>
            </div>
            <img src={gif_file} alt="gif file" className="gif-icon" />
            <div>
                <img src={id} alt="gif file" className="icon" />
                <h1>TRUSTMEE-ID Benefits</h1>
                <p style={{ maxWidth: "980px" }}>A unique TRUSTMEE-ID (TMID) is generated by product manufacturer inside product packaging.<br />
                    When scanned, It logs data in the Client Portal, verifying the product’s authenticity by showing if it’s been scanned before.
                    Each TMID is valid for a single scan once used, It becomes invalid to prevent reuse.</p>
            </div>
            <div className='button-container'>
                <h1 style={{ paddingRight: "3rem", paddingTop: "1rem",fontWeight: "600" }}>Visit our website at</h1>
                <button
                    className='blue-button'
                    onClick={() => window.open('https://www.trustmeeapp.com', '_blank')} style={{margin: "1rem"}}
                >
                    www.trustmeeapp.com
                </button>
            </div>
        </div>
    );
};

export default ProductTrustmee;
